import { CSSProperties } from 'react';
import styled from 'styled-components';

import { BodilColor } from '~src/branding';
import { ThumbnailWithUrl } from '~src/components/ThumbnailWithUrl';
import { Heading } from '~src/components/Typography';
import { useDisplay } from '~src/hooks/useDisplay';

const IMAGE_SIZE_DESKTOP = 142;
const IMAGE_SIZE_MOBILE = 118;
const COMBINED_IMAGE_SIZE = 79;

const CombinedProductImageWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

const ProductTag = styled(Heading)<{ background?: CSSProperties['color'] }>(
  ({ background = BodilColor.ui.action.default }) => ({
    position: 'absolute',
    top: -10,
    right: 0,
    background,
    borderRadius: 20,
    padding: '4px 12px',
  })
);

const ProductImageWrapper = styled.div<{ isMobile?: boolean; isCombined?: boolean }>(({ isMobile, isCombined }) => ({
  ...(isMobile && isCombined && { width: '100%' }),
  paddingTop: '24px',
  display: 'flex',
  justifyContent: 'center',
}));

type ProductImageProps = {
  tagColor?: CSSProperties['color'];
  heatPumpImage?: string | null;
  solarImage?: string | null;
};

export const ProductImage = ({ tagColor, heatPumpImage, solarImage }: ProductImageProps) => {
  const { isMobile } = useDisplay();

  const imageSize = isMobile ? IMAGE_SIZE_MOBILE : IMAGE_SIZE_DESKTOP;
  const combinedImageSize = isMobile ? IMAGE_SIZE_MOBILE : COMBINED_IMAGE_SIZE;

  const isCombined = !!heatPumpImage && !!solarImage;

  return (
    <ProductImageWrapper isMobile={isMobile} isCombined={isCombined}>
      <div style={{ position: 'relative', width: 'fit-content' }}>
        {isCombined ? (
          <CombinedProductImageWrapper>
            <ThumbnailWithUrl imageUrl={heatPumpImage} width={combinedImageSize} height={combinedImageSize} />

            <ThumbnailWithUrl imageUrl={solarImage} width={combinedImageSize} height={combinedImageSize} />
          </CombinedProductImageWrapper>
        ) : (
          <ThumbnailWithUrl imageUrl={heatPumpImage ?? solarImage} width={imageSize} height={imageSize} />
        )}
        <ProductTag background={tagColor} level={4} color='light'>
          Bedste pris
        </ProductTag>
      </div>
    </ProductImageWrapper>
  );
};
